<div>
    <input type="file" id="file-id" class="input-file" (change)="handleFileInput($event)"
        (click)="$event.target.value = null" [disabled]="isVisualization">
    <label class="mat-stroked-button" [ngClass]="{'avoid-clicks': isVisualization}" for="file-id">
        <span class="mat-button-wrapper">Upload de Arquivo</span>
        <div *ngIf="!isVisualization" class="mat-button-ripple mat-ripple" matripple="" ng-reflect-centered="false" ng-reflect-disabled="false"
            ng-reflect-trigger="[object HTMLLabelElement]"></div>
        <div *ngIf="!isVisualization" class="mat-button-focus-overlay"></div>
    </label>
</div>